import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TDeleteInvoiceTemplateRequest,
  TDeleteInvoiceTemplateResponse,
} from "./deleteInvoiceTemplate.schema";

export const deleteInvoiceTemplate = (axios: IAxiosInstance) => {
  return async (
    params: TDeleteInvoiceTemplateRequest
  ): Promise<TDeleteInvoiceTemplateResponse> => {
    const response = await axios.noRetry.delete<
      IApiResponse<TDeleteInvoiceTemplateResponse>
    >(`/api/invoices/templates/${params.id}`, {
      data: {
        companyID: params.companyID,
      },
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
